import { render } from "./FrmDumpMerchandiseConfiguration.vue?vue&type=template&id=978d9bb0"
import script from "./FrmDumpMerchandiseConfiguration.vue?vue&type=script&lang=js"
export * from "./FrmDumpMerchandiseConfiguration.vue?vue&type=script&lang=js"

import "./FrmDumpMerchandiseConfiguration.vue?vue&type=style&index=0&id=978d9bb0&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__